import { CategoryReq } from "../../types/dealType";
import { Category } from "../../types/productType";

export const mainCategory:Category[] = [
    {
      name: "Men",
      categoryId: "men",
      level: 1,
      parentCategoryId:null
    },
    {
      name:"Women",
      categoryId:"women",
      level:1,
      parentCategoryId:null
    },
    {
      name:"Home & Funiture",
      categoryId:"home_furniture",
      level:1,
      parentCategoryId:null
    },
    {
      name:"Electronics",
      categoryId:"electronics",
      level:1,
      parentCategoryId:null
    },
    {
      name:"Beauty",
      categoryId:"beauty",
      level:1,
      parentCategoryId:null
    }
  ];
  export const mainCategoryReq:CategoryReq[] = [
    {
      name: "Men",
      categoryId: "men",
      level: 1,
      parentCategoryId:null
    },
    {
      name:"Women",
      categoryId:"women",
      level:1,
      parentCategoryId:null
    },
    {
      name:"Home & Funiture",
      categoryId:"home_furniture",
      level:1,
      parentCategoryId:null
    },
    {
      name:"Electronics",
      categoryId:"electronics",
      level:1,
      parentCategoryId:null
    },
    {
      name:"Beauty",
      categoryId:"beauty",
      level:1,
      parentCategoryId:null
    }
  ];